import palette from "../palette";

export default {
    paper: {
        marginTop: '6px',   
        backgroundColor: 'white', 
        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
        borderRadius: '12px !important',
        minWidth: 170,
        border: `1px solid ${palette?.background?.switchDisabled} !important`
    },
}